/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_Native_GroupInputs */

const cs_listing_portals_native_group = /** @type {(inputs: Listing_Portals_Native_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatní portály (čeká na API)`)
};

const en_listing_portals_native_group = /** @type {(inputs: Listing_Portals_Native_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other portals (pending API)`)
};

/**
* | output |
* | --- |
* | "Other portals (pending API)" |
*
* @param {Listing_Portals_Native_GroupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_native_group = /** @type {((inputs?: Listing_Portals_Native_GroupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_Native_GroupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_native_group(inputs)
	return cs_listing_portals_native_group(inputs)
});